import axios from 'axios';
import qs from 'querystring';

const baseUrl = window.wp_baseUrl
  ? window.wp_baseUrl['base']
  : 'http://mano.local/';
const ApiUrl = 'wp-json/cts/v1';

export async function getOrigins() {
  return axios
    .get(`${baseUrl}/${ApiUrl}/origins`)
    .then((response) => response.data)
    .catch((error) => console.log(error));
}
export async function getDestinations() {
  return axios
    .get(`${baseUrl}/${ApiUrl}/destinations`)
    .then((response) => response.data)
    .catch((error) => console.log(error));
}
export async function getSearchRates(filters) {
  return axios
    .get(`${baseUrl}/${ApiUrl}/search-rates?${qs.stringify(filters)}`)
    .then((response) => response.data)
    .catch((error) => console.log(error));
}
